// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"8eca31ba","453":"acca0757","552":"8ca9cbd9","672":"093fbd1d"}[chunkId] + ".chunk.js";
};